<template>
  <div class="modal">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      fullscreen
      transition="fade-transition"
      content-class="ims-standard-dialog"
    >
      <v-card class="ims-modal-card">
        <!-- Popup Toolbar -->
        <v-toolbar color="elevation-0">
          <v-toolbar-title>
            <h2 id="myModalLabel">Edit Campaign</h2>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-container fluid grid-list-lg class="ims-modal-body">
          <v-layout>
            <!-- Company/ Client assignment -->
            <v-flex v-if="editClient" xs12 md6>
              <v-autocomplete
                filled
                :items="client_options"
                label="Client"
                item-value="id"
                hide-details
                item-text="name"
                v-model="campaign.clientID"
                @change="setClientData(campaign)"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <!-- <v-layout>
              <v-flex xs12>
                <v-card width="100%">
                  <v-card-title class="title grey lighten-2">
                    Assigned AM & CO
                  </v-card-title>
                  <v-card-text class="grey lighten-3">
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-subheader>
                          Assigned AM
                        </v-subheader>
                        <v-divider style="margin-top:0px;"></v-divider>
                        <v-chip-group multiple active-class="primary--text" v-model="selectedAM" column>
                          <v-chip v-for="(item, index) in AM.filter(v => v.id !== currentUserID)" :key="index" :value="item"
                            class="ma-2"
                            filter
                          >
                            <v-avatar style="margin-right:5px;">
                              <v-icon>account_circle</v-icon>
                            </v-avatar>
                            {{item.firstName + ' ' + item.lastName}}
                          </v-chip>
                        </v-chip-group>
                      </v-col>
                      <v-col sm="12" md="6" lg="6">
                        <v-subheader>
                         Assigned CO
                        </v-subheader>
                        <v-divider style="margin-top:0px;"></v-divider>
                        <v-chip-group multiple active-class="primary--text" v-model="selectedCO" column>
                          <v-chip v-for="(item, index) in CO.filter(v => v.id !== currentUserID )" :key="index" :value="item"
                            class="ma-2"
                            filter
                          >
                              <v-avatar style="margin-right:5px;">
                                <v-icon>account_circle</v-icon>
                              </v-avatar>
                              {{item.firstName + ' ' + item.lastName}}
                            </v-chip>
                          </v-chip-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout> -->
          <v-layout>
            <v-flex xs12>
              <v-card width="100%">
                <v-card-title class="title grey lighten-2">
                  Assigned Team
                </v-card-title>
                <v-card-text class="grey lighten-3">
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="6">
                      <v-subheader class="font-weight-bold">
                        Dedicated Persons
                      </v-subheader>
                      <v-divider style="margin-top:0px;"></v-divider>
                      <v-chip-group active-class="secondary--text" v-model="selectedDedicatedPersons" column>
                        <div style="width:100%" :key="typeIndex" v-for="(userType, typeIndex) in userTypes">
                          <p class="h4 font-weight-bold mb-0 pl-3" v-if="filterByRole(dedicatedPersons, userType.role).length > 0">{{userType.title}}</p>
                          <v-chip v-for="(item, index) in filterByRole(dedicatedPersons, userType.role)" :key="index"   :value="item"
                            class="ma-2"
                            filter
                          >
                            <v-avatar style="margin-right:5px;">
                              <v-icon>account_circle</v-icon>
                            </v-avatar>
                            {{item.firstName + ' ' + item.lastName}}
                          </v-chip>
                        </div>
                      </v-chip-group>
                    </v-col>
                    <v-col sm="12" md="6" lg="6">
                      <v-subheader v-show="supportingPersons.length > 0">
                        Supporting Persons
                      </v-subheader>
                      <v-divider v-show="supportingPersons.length > 0" style="margin-top:0px;"></v-divider>
                      <v-chip-group multiple active-class="secondary--text" v-model="selectedSupportingPersons" column v-show="supportingPersons.length > 0">
                        <div style="width:100%" :key="typeIndex" v-for="(userType, typeIndex) in userTypes">
                          <p class="h4 font-weight-bold mb-0 pl-3" v-if="filterByRole(supportingPersons, userType.role).length > 0">{{userType.title}}</p>
                          <v-chip v-for="(item, index) in filterByRole(supportingPersons, userType.role)" :key="index"  :value="item"
                          class="ma-2"
                          filter
                        >
                            <v-avatar style="margin-right:5px;">
                              <v-icon>account_circle</v-icon>
                            </v-avatar>
                            {{item.firstName + ' ' + item.lastName}}
                          </v-chip>
                        </div>
                      </v-chip-group>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-layout
                v-for="section in campaignModelSections"
                :name="section.title"
                :key="section.type"
              >
                <v-flex xs12>
                  <v-card width="100%">
                    <v-card-title class="title grey lighten-2">
                      {{section.title}}
                      <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="grey lighten-3">
                      <v-container>
                        <v-layout
                          wrap
                          v-if="
                            (section.type === campaignModelSectionType.CAMPAIGN_SUMMARY) ||
                            (section.type === campaignModelSectionType.INFLUENCER_SELECTION) ||
                            (section.type === campaignModelSectionType.BUDGET_ALLOCATION) ||
                            (section.type === campaignModelSectionType.VIDEO_BRIEF && showVideoBrief)"
                        >
                          <!-- For Campaign Summary, Influencer Selection, Video Brief sections, Budget Allocation -->
                          <v-flex xs12 v-if="section.type === campaignModelSectionType.BUDGET_ALLOCATION" >
                            <v-btn
                                color="info"
                                elevation="4"
                                @click="viewClientDialog = true"
                              >
                                Client Details
                                <v-icon
                                  right
                                  dark
                                >
                                  mdi-account-details
                                </v-icon>
                              </v-btn>
                          </v-flex>
                          <v-flex
                            xs12
                            md6
                            xl4
                            v-for="campaignField in section.content"
                            :key="campaignField.name"
                          >
                            <div
                              v-if="campaignField.type === 'text' && campaignField.name === 'vertical'"
                              v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                            >
                              <label>{{ campaignField.label }}</label>
                              <v-combobox
                                v-model="selectedCampaignVertical"
                                :items="campaignVerticals"
                                item-text="name"
                                item-value="name"
                                hide-selected
                                chips
                                :label="campaignField.placeholder"
                                multiple
                                solo
                                attach
                              >
                                <!-- <template v-slot:no-data>
                                  <v-list-item>
                                    <span class="subheading pr-2">Press Enter to Create</span>
                                    <v-chip
                                      label
                                      small
                                    >
                                      {{ newCampaignVertical }}
                                    </v-chip>
                                  </v-list-item>
                                </template> -->
                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                  <v-chip
                                    v-if="item === Object(item)"
                                    v-bind="attrs"
                                    :input-value="selected"
                                    label
                                    small
                                  >
                                    <span class="pr-2">
                                      {{ item.name }}
                                    </span>
                                    <v-icon
                                      small
                                      @click="parent.selectItem(item)"
                                    >
                                      $delete
                                    </v-icon>
                                  </v-chip>
                                </template>
                              </v-combobox>
                            </div>

                            <div
                              v-else-if="campaignField.type === 'text' || campaignField.type === 'slider'"
                            >
                              <label>{{ campaignField.label }}</label>
                              <v-text-field
                                solo
                                :placeholder="campaignField.placeholder"
                                v-model="campaign[campaignField.name]"
                                :disabled="campaignField.name==='budget'?true:false"
                              ></v-text-field>
                            </div>

                          <div
                            v-if="campaignField.type === 'textarea'"
                            v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-textarea
                              solo
                              :placeholder="campaignField.placeholder"
                              v-model="campaign[campaignField.name]"
                            ></v-textarea>
                          </div>

                            <div v-if="campaignField.type === 'combobox'">
                              <label>{{ campaignField.label }}</label>
                              <v-combobox
                                v-model="campaign[campaignField.name]"
                                :items="campaignField.items"
                                multiple
                                solo
                                chips
                                :placeholder="campaignField.placeholder"
                                v-if="campaignField.name === 'targetAge'"
                                v-on:input="targetAgelimiter"
                              ></v-combobox>
                              <!-- <v-combobox
                                v-model="campaign[campaignField.name]"
                                :items="campaignField.items"
                                item-text="name"
                                item-value="code"
                                multiple
                                solo
                                chips
                                :placeholder="campaignField.placeholder"
                              ></v-combobox> -->
                              <v-autocomplete
                                :search-input.sync="newCountry"
                                v-model="campaign[campaignField.name]"
                                :items="countries"
                                item-text="name"
                                item-value="code"
                                hide-selected
                                multiple
                                solo
                                chips
                                label="Country"
                                dense
                                v-else-if="campaignField.name === 'targetLocation'"
                              >
                                <!-- <template v-slot:no-data>
                                  <v-list-item>
                                    <span class="subheading pr-2">Press Enter to Create</span>
                                    <v-chip
                                      label
                                      small
                                    >
                                      {{ newCountry }}
                                    </v-chip>
                                  </v-list-item>
                                </template> -->
                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                  <v-chip
                                    v-if="item === Object(item)"
                                    v-bind="attrs"
                                    :input-value="selected"
                                    label
                                    small
                                  >
                                    <span class="pr-2">
                                      {{ item.name }}
                                    </span>
                                    <v-icon
                                      small
                                      @click="parent.selectItem(item)"
                                    >
                                      $delete
                                    </v-icon>
                                  </v-chip>
                                  <v-chip
                                    v-else
                                    v-bind="attrs"
                                    :input-value="selected"
                                    label
                                    small
                                  >
                                    <span class="pr-2">
                                      {{ item }}
                                    </span>
                                    <v-icon
                                      small
                                      @click="parent.selectItem(item)"
                                    >
                                      $delete
                                    </v-icon>
                                  </v-chip>
                                </template>
                              </v-autocomplete>
                              <v-combobox
                                v-model="campaign[campaignField.name]"
                                :items="campaignField.items"
                                multiple
                                solo
                                chips
                                :placeholder="campaignField.placeholder"
                                v-else
                              ></v-combobox>
                            </div>

                            <div v-if="campaignField.type === 'select'">
                              <label>{{ campaignField.label }}</label>
                              <v-select v-if="campaignField.name === 'ioNumbers'"
                                solo
                                :name="campaignField.name"
                                :items="IONumbers"
                                item-text="text"
                                item-value="value"
                                v-model="campaign[campaignField.name]"
                              ></v-select>
                              <v-select v-if="campaignField.name !== 'ioNumbers' && campaignField.name !== 'name'"
                                solo
                                :name="campaignField.name"
                                :items="campaignField.value"
                                item-text="text"
                                item-value="value"
                                v-model="campaign[campaignField.name]"
                              ></v-select>
                              <v-select
                                solo
                                :name="campaignField.name"
                                :items="campaignField.value"
                                item-text="text"
                                item-value="value"
                                v-model="campaign[campaignField.name]"
                                v-if="campaignField.name !== 'ioNumbers' && campaignField.name === 'name'"
                                @change="changeCampaignName(campaign[campaignField.name])"
                              ></v-select>
                            </div>

                            <div v-if="campaignField.type === 'autocomplete'">
                              <label>{{ campaignField.label }}</label>
                              <v-autocomplete
                                v-model="campaign[campaignField.name]"
                                :items="campaignField.value"
                                item-text="text"
                                item-value="value"
                                hide-selected
                                chips
                                :label="campaignField.placeholder"
                                multiple
                                solo
                                attach
                              >
                                <template v-slot:selection="{ attrs, item, parent, selected }">
                                  <v-chip
                                    v-if="item === Object(item)"
                                    v-bind="attrs"
                                    :input-value="selected"
                                    label
                                    small
                                  >
                                    <span class="pr-2">
                                      {{ item.text }}
                                    </span>
                                    <v-icon
                                      small
                                      @click="parent.selectItem(item)"
                                    >
                                      $delete
                                    </v-icon>
                                  </v-chip>
                                </template>
                              </v-autocomplete>
                            </div>

                            <div
                              v-if="campaignField.type === 'chips'"
                            >
                              <label>{{ campaignField.label }}</label>
                              <div>
                                <draggable v-model="campaign[campaignField.name]" style="width:100%;" class="row no-gutters flex-wrap flex-row fill-height" >
                                  <v-chip v-for="(item, index) in campaign[campaignField.name]" :key="index"  :value="item"
                                    class="ma-2"
                                    filter
                                  >
                                    {{item.text}}
                                  </v-chip>
                                </draggable>
                              </div>
                            </div>

                            <div v-if="campaignField.type == 'upload'">
                              <a
                                :href="constructImageURL(campaign[campaignField.name])"
                                target="_blank"
                                class="campaign-image"
                              >
                                <img
                                  style="width:100%"
                                  :src="constructImageURL(campaign[campaignField.name])"
                                />
                                <div class="canvas-image-input">
                                  <input type="file" ref="files" @change="processImage($event, 'canvas', null, 'canvas')" />
                                </div>
                              </a>
                            </div>

                            <div
                              v-if="campaignField.type === 'date' && campaignField.name === 'startDate'"
                            >
                              <label>{{ campaignField.label }}</label>
                              <v-menu
                                v-model="startCal"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="campaign[campaignField.name]"
                                    append-icon="event"
                                    readonly
                                    solo
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  type="month"
                                  v-model="campaign[campaignField.name]"
                                  @input="startCal = false"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                            <div
                              v-if="campaignField.type === 'date' && campaignField.name === 'endDate'"
                            >
                              <label>{{ campaignField.label }}</label>
                              <v-menu
                                v-model="endCal"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="campaign[campaignField.name]"
                                    append-icon="event"
                                    readonly
                                    solo
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  type="month"
                                  v-model="campaign[campaignField.name]"
                                  @input="endCal = false"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                            <div v-if="campaignField.type === 'radio'">
                              <label>{{campaignField.label}}</label>
                              <v-radio-group
                                v-model="campaign[campaignField.name]"
                                row
                              >
                                <v-radio
                                  label="by engagement"
                                  value="engagement"
                                ></v-radio>
                                <v-radio
                                  label="by contents"
                                  value="content"
                                ></v-radio>
                              </v-radio-group>
                            </div>
                            <div
                              v-if="campaignField.type === 'date' && campaignField.name === 'video_live_date'"
                            >
                              <label>{{ campaignField.label }}</label>
                              <v-menu
                                v-model="videoDateDialog"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="campaign[campaignField.name]"
                                    append-icon="event"
                                    readonly
                                    solo
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="campaign[campaignField.name]"
                                  @input="videoDateDialog = false"
                                ></v-date-picker>
                              </v-menu>
                            </div>
                          </v-flex>
                        </v-layout>
                        <v-layout
                          wrap
                          v-if="section.type === campaignModelSectionType.CONTENT_ANGLE"
                        >
                          <!-- For Content Angle Section -->
                          <v-flex
                            xs12
                            v-for="campaignField in section.content"
                            :key="campaignField.name"
                          >
                            <div v-if="campaignField.type === 'select'" class="action-required">
                              <label>{{ campaignField.label }}</label>
                              <v-select
                                solo
                                :name="campaignField.name"
                                :items="campaignField.value"
                                item-text="text"
                                item-value="value"
                                v-model="campaign[campaignField.name]"
                              ></v-select>
                            </div>
                            <div v-if="campaignField.type === 'multiple_options'">
                              <div
                                v-for="(option, optionIndex) in campaign[campaignField.name]"
                                :key="optionIndex"
                              >
                                <h4>
                                  {{ campaignField.label }} {{ optionIndex + 1 }}
                                  <v-btn
                                    text
                                    icon
                                    color="red"
                                    v-if="campaign[campaignField.name].length > 1"
                                    @click.stop="deleteOption(campaignField.name, optionIndex)"
                                  >
                                    <i class="fa fa-trash ims-text-error"></i>
                                  </v-btn>
                                </h4>
                                <v-container>
                                  <v-layout wrap>
                                    <v-flex
                                      xs12
                                      v-for="(optionField, i) in campaignField.template"
                                      :key="i"
                                    >
                                      <div v-if="optionField.type == 'text'">
                                        <label>{{ optionField.label }}</label>
                                        <v-text-field
                                          solo
                                          v-model="campaign[campaignField.name][optionIndex][optionField.name]"
                                          :placeholder="optionField.placeholder"
                                        ></v-text-field>
                                      </div>

                                      <div v-if="optionField.type == 'textarea'">
                                        <label>{{ optionField.label }}</label>
                                        <v-textarea
                                          solo
                                          auto-grow
                                          v-model="campaign[campaignField.name][optionIndex][optionField.name]"
                                          :placeholder="optionField.placeholder"
                                        ></v-textarea>
                                      </div>

                                      <div v-if="optionField.type == 'multiple_options'">
                                          <div v-for="(secondOption, secondOptionIndex) in campaign[campaignField.name][optionIndex][optionField.name]" :key="secondOptionIndex">
                                            <h4>
                                              Required action {{ secondOptionIndex + 1 }}
                                              <v-btn
                                                text
                                                icon
                                                color="red"
                                                v-if="campaign[campaignField.name][optionIndex][optionField.name].length > 1"
                                                @click.stop="deleteSecondOption(campaignField.name, optionIndex, optionField.name, secondOptionIndex)"
                                              >
                                                <i class="fa fa-trash ims-text-error"></i>
                                              </v-btn>
                                            </h4>
                                            <v-layout wrap v-for="(optionField2, optionIndex2) in optionField.template" :key="optionIndex2">
                                              <v-flex
                                                xs6
                                                v-for="(format, i) in optionField2"
                                                :key="i"
                                              >
                                                <div v-if="format.type == 'text'">
                                                  <label>{{ format.label }}</label>
                                                  <v-text-field
                                                    solo
                                                    v-model="campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                    :placeholder="format.placeholder"
                                                  ></v-text-field>
                                                </div>

                                                <div v-if="format.type == 'textarea'">
                                                  <label>{{ format.label }}</label>
                                                  <v-textarea
                                                    solo
                                                    v-model="campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                    :placeholder="format.placeholder"
                                                  ></v-textarea>
                                                </div>
                                                <div v-if="format.type === 'combobox'">
                                                  <label>{{ format.label }}</label>
                                                  <v-combobox
                                                    v-model="campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                    :items="format.items"
                                                    multiple
                                                    solo
                                                    chips
                                                    :placeholder="format.placeholder"
                                                    append-icon=""
                                                  ></v-combobox>
                                                </div>
                                                <div v-if="format.type == 'upload'">
                                                  <label>{{ format.label }}</label>
                                                  <div
                                                    v-for="(image, i) in campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                    :key="image"
                                                  >
                                                    <a
                                                      :href="constructImageURL(image.url)"
                                                      target="_blank"
                                                      class="campaign-image"
                                                      v-if="image.type === 'image'"
                                                    >
                                                      <img
                                                        style="width:100%"
                                                        :src="constructImageURL(image.url)"
                                                        v-if="image.url"
                                                      />
                                                    </a>
                                                    <a
                                                      :href="image.url"
                                                      target="_blank"
                                                      class="campaign-image"
                                                      v-if="image.type === 'link'"
                                                    >
                                                      <iframe class="media-iframe" width="120px" height="100%" :src="image.url" v-if="checkMediaURL(image.url) === 'drive'" allowFullScreen></iframe>
                                                      <p v-else>{{image.url}}</p>
                                                    </a>
                                                    <button
                                                      type="button"
                                                      class="btn btn-link btn-link-danger"
                                                      @click.prevent="removeUploadedImage(optionIndex, secondOptionIndex, i)"
                                                    >Remove</button>
                                                  </div>
                                                  <div
                                                    class="image-input-container"
                                                    :id="'optionImages_' + optionIndex + '_' + secondOptionIndex"
                                                    :data-index="optionIndex"
                                                  >
                                                    <div class="input-group pb-2" :id="'input_group_0_' + optionIndex + '_' + secondOptionIndex">
                                                      <label class="pr-2">
                                                        <input type='radio' :id="'radio_image_' + optionIndex + '_' + secondOptionIndex" :name="'type_' + optionIndex + '_' + secondOptionIndex" value="image" checked="true" @change="changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'image')" /> Image
                                                      </label>
                                                      <label>
                                                        <input type='radio' :id="'radio_link_' + optionIndex + '_' + secondOptionIndex" :name="'type_' + optionIndex + '_' + secondOptionIndex" value='link' @change="changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'link')" /> Video Link
                                                      </label>
                                                      <div>
                                                        <input type="text" class="custom-input" style="display:none" :id="'video_link_0_' + optionIndex + '_' + secondOptionIndex" @keyup="changeVideoLink('angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)" />
                                                      </div>
                                                      <div class="image-input" :id="'img_upload_0_' + optionIndex + '_' + secondOptionIndex">
                                                        <input
                                                          type="file"
                                                          ref="files"
                                                          @change="processImage($event, 'angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)"
                                                        />
                                                      </div>
                                                    </div>
                                                    <button
                                                      type="button"
                                                      class="btn btn-link btn-link-danger btn-remove-input"
                                                      @click.prevent="removeImage(optionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)"
                                                    >Remove</button>
                                                  </div>
                                                  <button
                                                    type="button"
                                                    class="btn btn-default btn-sm btn-add-more-image"
                                                    @click="addMoreImage(optionIndex, secondOptionIndex)"
                                                  >+ Add more image</button>
                                                </div>
                                              </v-flex>
                                            </v-layout>
                                          </div>
                                          <v-btn
                                            small
                                            class="default"
                                            @click="addSecondOption(campaignField.name, optionIndex, optionField.name)"
                                          >+ Add more angle</v-btn>
                                      </div>

                                      <!-- <div v-if="optionField.type == 'upload'">
                                        <label>{{ optionField.label }}</label>
                                        <div class>
                                          <div
                                            v-for="(image, i) in campaign[campaignField.name][optionIndex][optionField.name]"
                                            :key="image"
                                          >
                                            <a
                                              :href="constructImageURL(image)"
                                              target="_blank"
                                              class="campaign-image"
                                            >
                                              <img
                                                style="width:100%"
                                                :src="constructImageURL(image)"
                                                v-if="image !== null"
                                              />
                                            </a>
                                            <button
                                              type="button"
                                              class="btn btn-link btn-link-danger"
                                              @click.prevent="removeUploadedImage(optionIndex, i)"
                                            >Remove</button>
                                          </div>
                                        </div>
                                        <div>
                                          <div
                                            class="image-input-container-edit"
                                            :id="'optionImages_' + optionIndex"
                                            :data-index="optionIndex"
                                          >
                                            <div
                                              :id="'img_upload_0_' + optionIndex"
                                              class="image-input-edit"
                                            >
                                              <input
                                                type="file"
                                                ref="files"
                                                accept="image/*"
                                                @change="processImage($event, 'angel', optionIndex, 0 + '_' + optionIndex)"
                                              />
                                              <button
                                                type="button"
                                                class="btn btn-link btn-link-danger btn-remove-input-edit"
                                                @click.prevent="removeImage(optionIndex, 0 + '_' + optionIndex)"
                                              >Remove</button>
                                            </div>
                                          </div>
                                          <button
                                            type="button"
                                            class="btn btn-default btn-sm"
                                            @click="addMoreImage(optionIndex)"
                                          >+ Add more image</button>
                                        </div>
                                      </div> -->
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </div>
                              <div>
                                <v-btn
                                  small
                                  class="secondary"
                                  @click="addOption(campaignField.name)"
                                >Add new option</v-btn>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                      <v-layout wrap v-if="section.type === campaignModelSectionType.EVENT_BRIEF && showEventBrief">
                        <!-- For Event Brief -->
                        <v-flex
                          xs12
                          v-for="campaignField in section.content"
                          :key="campaignField.name"
                        >
                          <div
                            v-if="campaignField.type === 'textarea'"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-textarea
                              solo
                              :placeholder="campaignField.placeholder"
                              v-model="campaign.eventBrief[campaignField.name]"
                            ></v-textarea>
                          </div>

                          <div v-if="campaignField.type === 'multiple_options'">
                            <h4>
                              {{ campaignField.label }}
                            </h4>
                            <div
                              v-for="(option, optionIndex) in campaign.eventBrief[campaignField.name]"
                              :key="optionIndex"
                            >
                              <v-container>
                                <v-layout wrap>
                                  <v-flex
                                    xs12
                                    md3
                                    v-for="(optionField, i) in campaignField.template"
                                    :key="i"
                                  >
                                    <div v-if="optionField.type == 'text'">
                                      <label>{{ optionField.label }}</label>
                                      <v-icon
                                        text icon color="red"
                                        v-if="campaign.eventBrief[campaignField.name].length > 1"
                                        v-show="optionField.name === 'attendeeName'"
                                        @click.stop="deleteAttendee(campaignField.name, optionIndex)"
                                      >delete</v-icon>
                                      <v-text-field
                                        solo
                                        v-model="campaign.eventBrief[campaignField.name][optionIndex][optionField.name]"
                                        :placeholder="optionField.placeholder"
                                      ></v-text-field>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </div>
                            <div>
                              <v-btn
                                small
                                class="secondary"
                                @click="addAttendee(campaignField.name)"
                              >Add an Attendee</v-btn>
                            </div>
                          </div>
                          <div v-if="campaignField.type === 'template'">
                            <h4>
                              {{ campaignField.label }}
                            </h4>
                            <v-container>
                              <v-layout wrap>
                                <v-flex
                                  xs12 md4
                                  v-for="(templateField, i) in campaignField.template"
                                  :key="i"
                                >
                                  <div v-if="templateField.type == 'text'">
                                    <label>{{ templateField.label }}</label>
                                    <v-text-field
                                      solo
                                      v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                      :placeholder="templateField.placeholder"
                                    ></v-text-field>
                                  </div>

                                  <div v-if="templateField.type === 'radioButton'">
                                    <label>{{ templateField.label }}</label>
                                    <v-checkbox
                                      v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                      :label="campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes': 'No'"
                                    ></v-checkbox>
                                  </div>

                                  <div
                                    v-if="templateField.type === 'date' && templateField.name === 'eventDate'"
                                  >
                                    <label>{{ templateField.label }}</label>
                                    <v-menu
                                      v-model="eventDateDialog"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                          append-icon="event"
                                          readonly
                                          solo
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                        @input="eventDateDialog = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </div>

                                  <div
                                    v-if="templateField.type === 'textarea'"
                                  >
                                    <label>{{ templateField.label }}</label>
                                    <v-textarea
                                      solo
                                      :placeholder="templateField.placeholder"
                                      v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                    ></v-textarea>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </v-flex>
                      </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- Footer -->
        <div class="modal-footer ims-modal-actions">
          <v-btn @click="close">Close</v-btn>
          <v-btn class="secondary" @click="editCampaign">Save changes</v-btn>
        </div>
      </v-card>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </v-dialog>
    <!-- ViewClient modal -->
    <view-client-modal :clientData="viewClientData" v-model="viewClientDialog"/>
  </div>
</template>

<script>
import $ from 'jquery';
// import { mapState } from 'vuex';
import campaignConfig from './config';
import campaignHelper from './campaignHelper';
import campaignAPIs from './campaignAPIs';
import clientAPIs from '../Client/clientAPIs';
import config from '@/config';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import utils from '../../../utils';
import ViewClientModal from '../Client/ViewClientModal'
import userAPIs from '../User/userAPIs'
import draggable from 'vuedraggable'
import countries from '../../../../static/sources/countries';

const campaignDataTemplate = {};

export default {
  name: 'EditCampaignModal',
  props: {
    value: Boolean,
    campaignId: String
  },
  components: {
    Loading,
    ViewClientModal,
    draggable
  },
  data() {
    return {
      isLoading: false,
      campaign: {},
      showBudget: false,
      showVideoBrief: false,
      showEventBrief: false,
      startCal: false,
      endCal: false,
      startTimeDialog: false,
      endTimeDialog: false,
      eventDateDialog: false,
      videoDateDialog: false,
      campaignModelSections: campaignConfig.campaignModelSections,
      campaignModelSectionType: campaignConfig.campaignModelSectionType,
      allClients: [],
      inputMoreImages: 1,
      images: [],
      angelOptions: [],
      viewClientData: null,
      viewClientDialog: false,
      AM: [],
      selectedAM: [],
      CO: [],
      selectedCO: [],
      dedicatedPersons: [],
      supportingPersons: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      IONumbers: [],
      campaignVerticals: [],
      selectedCampaignVertical: [],
      userTypes: [
        {
          title: 'AM',
          role: config.userRoles.ACCOUNT_MANAGER
        },
        {
          title: 'CC',
          role: config.userRoles.AD_STRATEGIST
        }
      ],
      countries: [] // For filter influencer
    };
  },
  watch: {
    campaignId: function(newCampaignId) {
      campaignAPIs
        .getCampaign(newCampaignId)
        .then(async (response) => {
          // To be Compatible with old campaign data
          this.showBudget = response.settings ? response.settings.showBudgetToClient : response.showBudgetToClient;
          this.showVideoBrief = response.settings ? response.settings.enableVideoBrief : response.enableVideoBrief;
          this.showEventBrief = response.settings ? response.settings.enableEventBrief : response.enableEventBrief;
          if (typeof response.targetAge === 'string') { // Nyein: fix for old single string targetAge
            response.targetAge = [response.targetAge]
          }
          if (typeof response.targetLocation === 'string') { // Nyein: fix for old single string targetLocation
            if (response.targetLocation === '-') {
              response.targetLocation = []
            } else {
              let location = campaignConfig.targetAudienceDisplay.LOCATION.find(l => l.text === response.targetLocation)
              if (location) response.targetLocation = [location.value]
            }
          }
          response.targetLocation = campaignHelper.formatCountry(this.countries, response.targetLocation || [])
          // remove Video Brief section if it is null
          if (!this.showVideoBrief) {
            let array = campaignConfig.campaignModelSections.filter(
              sections => sections.type !== this.campaignModelSectionType.VIDEO_BRIEF
            );
            this.campaignModelSections = array;
          } else {
            this.campaignModelSections = campaignConfig.campaignModelSections;
          }
          // remove Event Brief section if it is null
          if (!this.showEventBrief) {
            let array = campaignConfig.campaignModelSections.filter(
              sections => sections.type !== this.campaignModelSectionType.EVENT_BRIEF
            );
            this.campaignModelSections = array;
          } else {
            this.campaignModelSections = campaignConfig.campaignModelSections;
          }
          response.angles = campaignHelper.fixAnglesData(response.angles)
          // platform
          // response.angles = response.angles.map(angle => {
          //   const cpAngle = Object.assign({}, angle);
          //   //  restructure array for multiple options, formats
          //   if (cpAngle.required_action) {
          //     cpAngle.formats = []
          //     let format = this.getAngleFormat()
          //     format.required_action = cpAngle.required_action
          //     format.image_angle = cpAngle.image_angle
          //     format.content_angle = cpAngle.content_angle
          //     let sampleImages = angle.sample_images ? angle.sample_images : [];
          //     if (cpAngle.sample_image) {
          //       sampleImages.push({type: 'image', url: cpAngle.sample_image});
          //     }
          //     format.sample_images = sampleImages
          //     delete cpAngle.required_action;
          //     delete cpAngle.image_angle;
          //     delete cpAngle.content_angle;
          //     delete cpAngle.sample_images;
          //     delete cpAngle.sample_image;
          //     cpAngle.formats.push(format)
          //   }
          //   // fix sample images old data
          //   cpAngle.formats = cpAngle.formats.map(formatOne => {
          //     if (formatOne.sample_images) {
          //       formatOne.sample_images = formatOne.sample_images.map(sampleImage => {
          //         if (!sampleImage.type) {
          //           if (this.checkIfImage(sampleImage)) {
          //             sampleImage = { type: 'image', url: sampleImage };
          //           } else {
          //             sampleImage = { type: 'link', url: sampleImage };
          //           }
          //         }
          //         return sampleImage
          //       })
          //     }
          //     return formatOne;
          //   })
          //   // delete cpAngle.sample_images;
          //   // delete cpAngle.sample_image;
          //   // cpAngle.sample_images = sampleImages;
          //   return cpAngle;
          // });
          if (response.segment) {
            let segments = []
            response.segment.map(s => {
              campaignDataTemplate.segment.map(s2 => {
                if (s === s2.value) {
                  segments.push(s2)
                }
              })
            })
            response.segment = segments
          }

          if (response.min_influencer || response.max_influencer) {
            /*
              old campaigns formats use 'min_influencer' & 'max_influencer' in database
              so, we override with new attributes for view
            */
            response.min_content = response.min_influencer;
            response.max_content = response.max_influencer;
            delete response.min_influencer;
            delete response.max_influencer;
          }
          // if the values aren't in array format, change to array format
          response.goal = Array.isArray(response.goal) ? response.goal : [response.goal];
          response.influencer_ideal = Array.isArray(response.influencer_ideal)
            ? response.influencer_ideal
            : response.influencer_ideal.split(',');
          response.influencer_unwanted = Array.isArray(response.influencer_unwanted)
            ? response.influencer_unwanted
            : response.influencer_unwanted.split(',');
          this.campaign = Object.assign(campaignDataTemplate, response);
          if (!response.platform) {
            this.campaign.platform = []
          } else {
            response.platform = response.platform.map(p => {
              let matchPlatform = campaignConfig.targetAudienceDisplay.PLATFORM.find(t => t.value === p)
              if (matchPlatform) {
                p = matchPlatform
              }
              return p
            })
            this.campaign.platform = Object.assign([], response.platform)
          }
          this.setClientData(this.campaign)
          this.getCampaignsByClientID(this.campaign.clientID)
          if (this.campaign.assignedTo) {
            // Get Selected CO
            /**
             * #NOTE
             * Making delay to this.CO assigned
             * #TODO find another solution to remove delay
             */
            setTimeout(() => {
              this.CO.map(item => {
                response.assignedTo.map(userId => {
                  if (item.id === userId) {
                    this.selectedCO.push(item)
                  }
                })
              })
            }, 500)

            // Get Selected AM
            this.AM.map(item => {
              response.assignedTo.map(userId => {
                if (item.id === userId) {
                  this.selectedAM.push(item)
                }
              })
            })
          }

          if (this.campaign.revenueCalculation === undefined || this.campaign.revenueCalculation === '') {
            this.campaign.revenueCalculation = 'content'
          }
          // Assign Selected Campaign vertical to campaignVertical array.
          campaignAPIs
          .getAllCampaignVerticals(false)
          .then(responsevertical => {
            this.campaignVerticals = [];
            this.campaignVerticals = responsevertical.data;
            this.selectedCampaignVertical = [];
            if (response.vertical) {
              this.campaignVerticals.map(item => {
                response.vertical.map(verticalId => {
                  if (item.id === verticalId) {
                    this.selectedCampaignVertical.push(item)
                  }
                })
              })
            }
          })
          .catch(error => {
            console.log('error', error);
          });

          this.getClientData(response.clientID)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    selectedCampaignVertical (val, prev) {
      if (val.length === prev.length) return

      this.selectedCampaignVertical = val.map(v => {
        if (typeof v === 'string') {
          v = {
            id: 0,
            name: v
          }
          this.campaignVerticals.push(v)
        }

        return v
      })
    }
  },
  validations: function() {
    const validationRules = {
      campaign: {}
    };
    this.campaignModelSections.forEach(section => {
      section.content.forEach(field => {
        if (field.validations && field.validations.length > 0) {
          if (field.validations) {
            field.validations.forEach(validation => {
              validationRules['campaign'][field.name] = {
                [validation.name]: validation.value
              };
            });
          }
        }
      });
    });

    return validationRules;
  },
  computed: {
    // ...mapState({
    //   countries: state => state.campaign.countries
    // }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    client_options: function() {
      let clientList = []
      this.allClients.forEach(element => {
        let client = {
          name: element.name,
          id: element.id
        }
        clientList.push(client)
      });
      return clientList;
    },
    editClient: function() {
      // only edit clients in Draft stage
      if (this.campaign.status === config.campaignStatus.DRAFT) {
        return true;
      }
      return false;
    }
  },
  methods: {
    setClientData: function(campaign) {
      let clientID = campaign.clientID
      // this.getClientData(clientID)
      clientAPIs
        .getClient(clientID)
        .then(response => {
          this.viewClientData = Object.assign({}, response);
          // this.getCOFromClient(response.handledBy, campaign.assignedTo)
          this.getPersonsFromClient(campaign, this.viewClientData)
          // console.log('CO in setClientData', this.CO)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    getClientData: function(clientID) {
      clientAPIs
        .getClient(clientID)
        .then(async response => {
          if (response.account.deals !== undefined) {
            response.account.deals.map(item => {
              this.IONumbers.push(item.IO)
            })
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    // getCOFromClient: function(handledBy, assignedTo) {
    //   this.CO = []
    //   this.selectedCO = []
    //   // Get all CO user by Client
    //   handledBy.map(async (userId) => {
    //     const response = await userAPIs.getUser(userId)
    //     if (response) {
    //       this.CO.push(response)
    //     }
    //     // .catch(error => {
    //     //   console.log('error', error);
    //     // });
    //   })
    //   /**
    //    * #NOTE
    //    * Making delay to this.CO assigned
    //    * #TODO find another solution to remove delay
    //    */
    //   setTimeout(() => {
    //     this.CO.map((item) => {
    //       assignedTo.map((id) => {
    //         if (item.id === id) {
    //           this.selectedCO.push(item)
    //         }
    //       })
    //     })
    //   }, 500)
    // },
    getPersonsFromClient: function(campaign, client) {
      this.dedicatedPersons = []
      this.selectedDedicatedPersons = []
      this.supportingPersons = []
      this.selectedSupportingPersons = []
      // Get all dedicated or supporting user by Client
      client.handledBy.map((userId) => {
        userAPIs
        .getUser(userId)
        .then(response => {
          this.dedicatedPersons.push(response)
          if (campaign.assignedTo) {
            if (campaign.assignedTo.includes(response.id)) {
              this.selectedDedicatedPersons.push(response)
            }
          } else {
            this.selectedDedicatedPersons.push(response)
          }
        })
        .catch(error => {
          console.log('error', error);
        });
      })
      if (client.supportedBy) {
        client.supportedBy.map((userId) => {
          userAPIs
          .getUser(userId)
          .then(response => {
            this.supportingPersons.push(response)
            if (campaign.assignedSupportingTo) {
              if (campaign.assignedSupportingTo.includes(response.id)) {
                this.selectedSupportingPersons.push(response)
              }
            } else {
              this.selectedSupportingPersons.push(response)
            }
          })
          .catch(error => {
            console.log('error', error);
          });
        })
      }
    },
    close() {
      this.$emit('input');
    },
    addMoreImage(optionIndex, secondOptionIndex) {
      let el = document.getElementById('optionImages_' + optionIndex + '_' + secondOptionIndex);
      let img = this.renderImageSelection(optionIndex, secondOptionIndex);
      let imgId = img.id;
      el.insertAdjacentHTML('beforeend', img.html);
      let btnRemove = document.getElementById('btnRemove_' + imgId);
      let inputFile = document.getElementById('inputFile_' + imgId);
      btnRemove.addEventListener('click', () => {
        this.removeImage(optionIndex, imgId);
      });
      inputFile.addEventListener('change', event => {
        this.processImage(event, 'angel', optionIndex, secondOptionIndex, imgId);
      });
      let imageRadio = document.getElementById('radio_image_' + imgId)
      imageRadio.addEventListener('change', event => {
        this.changeOptionType(imgId, 'image')
      });
      let linkRadio = document.getElementById('radio_link_' + imgId)
      linkRadio.addEventListener('change', event => {
        this.changeOptionType(imgId, 'link')
      });
      let videoLinkInput = document.getElementById('video_link_' + imgId)
      videoLinkInput.addEventListener('change', event => {
        this.changeVideoLink('angel', optionIndex, secondOptionIndex, imgId)
      });
    },
    removeImage(optionIndex, imgId) {
      var el = document.getElementById('input_group_' + imgId);
      el.remove();
      utils.func.removeElementFromArray(this.images, imgId, 'imgId', utils.TYPE.OBJECT);
      utils.func.removeElementFromArray(this.angelOptions, imgId, 'imgId', utils.TYPE.OBJECT);
    },
    renderImageSelection(optionIndex) {
      let imgIndex = utils.func.makeid(6);
      return {
        html: `
        <div class="input-group pb-2" id="input_group_${imgIndex}">
          <label class="pr-2">
            <input type='radio' id="radio_image_${imgIndex}" name="type_${imgIndex}" value='image' checked="true" /> Image
          </label>
          <label>
            <input type='radio' id="radio_link_${imgIndex}" name="type_${imgIndex}" value='link' /> Video Link
          </label>
          <div>
            <input type="text" class="custom-input" style="display:none" id="video_link_${imgIndex}" />
          </div>
          <div
            class="image-input" id="img_upload_${imgIndex}"
          >
            <input
              type="file"
              id="inputFile_${imgIndex}"
              ref="files"
            />
          </div>
        </div>
        <button
          type="button"
          id="btnRemove_${imgIndex}"
          class="btn btn-link btn-link-danger btn-remove-input"
        >Remove</button>`,
        id: imgIndex
      };
    },
    processImage: function(e, type, opt, opt2, imgId) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        utils.func.pushElementToArray(this.angelOptions, { opt, opt2, name: element.name, type, imgId }, 'imgId', utils.TYPE.OBJECT);
        utils.func.pushElementToArray(this.images, { element, imgId, opt, opt2 }, 'imgId', utils.TYPE.OBJECT);
      });
    },
    editCampaign: function() {
      if (this.campaign.platform && this.campaign.platform.length) {
        this.campaign.platform = this.campaign.platform.filter(p => typeof p !== 'string')
      }
      if (this.campaign.campaignType === campaignConfig.campaignType.NO_PREFERENCE ||
      this.campaign.campaignType === undefined) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Product Type.'
        });
        return;
      } else if (!this.campaign.targetLocation || !this.campaign.targetLocation.length) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Target Location'
        });
        return;
      } else if (!this.campaign.platform.length) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Platform'
        });
        return;
      } else if (this.selectedCampaignVertical.length === 0) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Campaign Vertical.'
        });
        return;
      }
      this.isLoading = true;
      // let AMUserList = []
      // let COUserList = []
      const campaign = Object.assign({}, this.campaign);
      const campaignID = campaign.id;

      delete campaign.id;

      // this.selectedAM.map((item) => {
      //   AMUserList.push(item.id)
      // })

      // this.selectedCO.map((item) => {
      //   COUserList.push(item.id)
      // })

      // let userList = AMUserList.concat(COUserList)
      // const userListSet = new Set(userList)
      // campaign.assignedTo = [...userListSet]
      campaign.assignedTo = this.selectedDedicatedPersons.map(d => d.id)
      campaign.assignedSupportingTo = this.selectedSupportingPersons.map(sp => sp.id)

      // Reassign Campaign Vertical data to store
      campaign.vertical = this.selectedCampaignVertical
      // check and assign segmentation
      campaign['segment'] = campaign['segment'] ? campaign['segment'].map(t => t.value) : []
      // check and assign target audience age
      if (campaign['targetAge']) {
        campaign['targetAge'] = campaign['targetAge'].map(t => {
          if (typeof t === 'object') {
            return t.value
          }
          return t
        })
      }
      // check and assign target aud location
      if (campaign['targetLocation']) {
        campaign['targetLocation'] = campaign['targetLocation'].map(v => {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            }
            // this.countries.push(v)
          }
          return v
        })
      }
      // check and assign target platform
      campaign['platform'] = campaign['platform'] ? campaign['platform'].map(t => t.value || '') : []

      let formData = new FormData();
      formData.append('campaign', JSON.stringify(campaign));
      formData.append('angelOptions', JSON.stringify(this.angelOptions));
      for (let val of this.images) {
        formData.append('images', val.element);
      }
      // Edit campaign
      campaignAPIs
        .editCampaign(campaignID, formData)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('editCampaign', response);
          this.isLoading = false;
          // Dismiss modal by triggering the click event on Close button
          this.$swal({
            text: 'Campaign Updated',
            type: 'success'
          }).then(result => {
            if (result.value) {
              this.close();
            }
          })
        })
        .catch(error => {
          // Request failed.
          this.isLoading = false;
          console.log('error', error);
        });
    },
    addAttendee: function(fieldName) {
      var attendeeField = this.campaign['eventBrief'][fieldName][0];
      var newAttendeeField = {}
      for (var key in attendeeField) {
        newAttendeeField[key] = '';
      }
      // var newAttendeeField = Object.assign({}, attendeeField);
      this.campaign['eventBrief'][fieldName].push(newAttendeeField);
    },
    deleteAttendee: function(fieldName, index) {
      var newAttendeeField = this.campaign['eventBrief'][fieldName];
      if (index < newAttendeeField.length) {
        newAttendeeField.splice(index, 1);
        this.campaign['eventBrief'][fieldName] = newAttendeeField;
      }
    },
    deleteOption: function(campaignAttribute, campaignAttributeIndex) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignAttributeIndex < campaignOptions.length) {
        campaignOptions.splice(campaignAttributeIndex, 1);
        this.campaign[campaignAttribute] = campaignOptions;
        this.angelOptions = this.angelOptions.filter((e) => {
          return e.opt !== campaignAttributeIndex
        })
        this.images = this.images.filter((e) => {
          return e.opt !== campaignAttributeIndex
        })
      }
    },
    deleteSecondOption: function(campaignAttribute, campaignAttributeIndex, optionName, optionIndex) {
      var secondOptions = this.campaign[campaignAttribute][campaignAttributeIndex][optionName]
      if (optionIndex < secondOptions.length) {
        secondOptions.splice(optionIndex, 1);
        this.campaign[campaignAttribute][campaignAttributeIndex][optionName] = secondOptions;
      }
    },
    addOption: function(campaignAttribute) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};
        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
          if (key === 'formats') {
            campaignOptionsTemplate[key] = [this.getAngleFormat()]
          }
        }

        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute] = campaignOptions;
      }
    },
    addSecondOption(campaignAttribute, optionIndex, optionName) {
      // add second option
      var campaignOptions = this.campaign[campaignAttribute][optionIndex][optionName];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};
        // default selection in newly added options
        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
          if (key === 'formats') {
            let format = this.getAngleFormat()
            campaignOptionsTemplate[key] = format
          }
        }
        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute][optionIndex][optionName] = campaignOptions;
      }
    },
    changeOptionType(elementID, value) {
      $(`#img_upload_${elementID}`).hide()
      $(`#video_link_${elementID}`).hide()
      if (value === 'image') {
        $(`#img_upload_${elementID}`).show()
      } else {
        $(`#video_link_${elementID}`).show()
      }
    },
    changeVideoLink(type, opt, opt2, imgId) {
      let value = $(`#video_link_${imgId}`).val()
      utils.func.pushElementToArray(this.angelOptions, { opt, opt2, name: value, type, optionType: 'link', imgId }, 'imgId', utils.TYPE.OBJECT);
    },
    constructImageURL: function(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    },
    checkMediaURL(url) {
      if (url.includes('drive.google.com')) { // for google drive link, replace the actual link with preview
        return 'drive'
      }
      return 'link'
    },
    clearData: function() {
      this.campaign = {
        name: '',
        goal: '',
        budget: ''
      };
    },
    getAngleFormat() {
      return Object.assign({}, {
        required_action: '',
        image_angle: '',
        content_angle: '',
        sample_images: ''
      })
    },
    changeCampaignName(name) {
      let campaignOne = this.clientCampaigns.find(c => c.name === name)
      if (typeof campaignOne.targetAge === 'string') {
        campaignOne.targetAge = [campaignOne.targetAge]
      }
      if (typeof campaignOne.targetLocation === 'string') {
        if (campaignOne.targetLocation === '-') {
          campaignOne.targetLocation = ''
        } else {
          let location = campaignConfig.targetAudienceDisplay.LOCATION.find(l => l.text === campaignOne.targetLocation)
          if (location) campaignOne.targetLocation = [location.value]
        }
      }
      campaignOne.goal = Array.isArray(campaignOne.goal) ? campaignOne.goal : [campaignOne.goal]
      campaignOne.influencer_ideal = Array.isArray(campaignOne.influencer_ideal) ? campaignOne.influencer_ideal : [campaignOne.influencer_ideal]
      campaignOne.influencer_unwanted = Array.isArray(campaignOne.influencer_unwanted) ? campaignOne.influencer_unwanted : [campaignOne.influencer_unwanted]
      this.campaign = utils.func.refreshJSON(campaignOne)
    },
    removeUpload() {
      this.inputMoreImages--;
    },
    removeUploadedImage(optionIndex, secondOptionIndex, i) {
      this.campaign.angles[optionIndex].formats[secondOptionIndex].sample_images.splice(i, 1);
    },
    onEnter(val) {
      this.campaignVertical.push(val);
      this.campaign['vertical'] = ''
    },
    removeChip(index) {
      this.campaignVertical.splice(index, 1)
    },
    targetAgelimiter(e) { // limit target age select to two
      if (e.length > 2) {
        e.pop()
      }
    },
    getCampaignsByClientID: function(clientID) {
      campaignAPIs
      .getCampaignsByClientID(clientID)
      .then(response => {
        this.campaignModelSections = this.campaignModelSections.map(section => {
          if (section.type === this.campaignModelSectionType.CAMPAIGN_SUMMARY) { // for campaign name
            // var eventObject = {};
            section.content.forEach(field => {
              if (field.name === 'name') {
                field.value = []
                this.clientCampaigns = response.campaigns
                response.campaigns.map(c => {
                  field.value.push(c.name)
                })
              }
            })
          }
          return section
        })
      })
      .catch(error => {
        // Request failed.
        console.log('error', error);
      });
    },
    filterByRole(users, role) {
      return users.filter(u => u.role === role)
    },
    getCountries() {
      // Retrieve countries manually
      this.countries = Object.assign([], countries)
      // influencerAPIs.getCountries().then(countries => {
      //   this.countries = countries.map(item => item.name);
      // });
    }
  },
  async mounted() {
    // Update client select options
    if (
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.AD_STRATEGIST ||
      this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
    ) {
      clientAPIs
        .getAllClients(false)
        .then(response => {
          this.allClients = response.data;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });

      // get all AM users
      userAPIs
        .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        .then(response => {
          this.AM = response.users;
        })
        .catch(error => {
          console.log('error', error);
        });

      // get all campaign verticals
      campaignAPIs
        .getAllCampaignVerticals(false)
        .then(response => {
          this.campaignVerticals = response.data;
        })
        .catch(error => {
          console.log('error', error);
        });
      // await this.$store.dispatch('campaign/getCountries')
      this.getCountries()
    }
    this.images = []
    this.angelOptions = []
  },
  beforeCreate() {
    // Update campaign data value based on campaign model
    campaignConfig.campaignModelSections.forEach(section => {
      if (section.type === campaignConfig.campaignModelSectionType.EVENT_BRIEF) { // for video-brief
        var eventObject = {};
        section.content.forEach(field => {
          if (field.type === 'multiple_options') {
            var optionObj = {};
            field.template.forEach(template => {
              optionObj[template.name] = '';
            })
            eventObject[field.name] = [optionObj];
          } else if (field.type === 'template') {
            var templateObj = {};
            field.template.forEach(template => {
              templateObj[template.name] = ''
            })
            eventObject[field.name] = templateObj;
          } else {
            eventObject[field.name] = '';
          }
        })
        campaignDataTemplate.eventBrief = eventObject;
      } else { // for other sections type
        section.content.forEach(field => {
          campaignDataTemplate[field.name] = '';

          if (field.type === 'select') {
            campaignDataTemplate[field.name] = field.defaultValue;
          } else if (field.type === 'multiple_options') {
            var newOption = {};
            field.template.forEach(template => {
              newOption[template.name] = '';
              if (template.type === 'select') {
                newOption[template.name] = template.defaultValue;
              } else if (template.type === 'multiple_options') {
                newOption[template.name] = []
                newOption[template.name].push({})
                template.template[0].forEach(secondTemplate => {
                  newOption[template.name][0][secondTemplate.name] = '';
                })
              }
            });
            campaignDataTemplate[field.name] = [newOption];
          } else if (field.type === 'chips') {
            campaignDataTemplate[field.name] = field.value;
          }
        });
      }
    });
  }
};
</script>

<style lang="scss">
.image-input-container-edit {
  margin-bottom: 10px;
  .image-input-edit {
    input {
      display: inline;
    }
  }
}
.campaign-image {
  display: inline-block;
  max-width: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  img {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// EditCampaignModal.vue?5f5b7e40